import React from 'react';
import { useTranslation } from 'react-i18next';

import {
  SearchKit,
  SearchLoadMore,
} from '@uncinc/uncinc-react-kitchen-sink';

import VolunteerWorkSearchBar from './Searchbar';
import VolunteerWorkSearchResults from './Results';

import { APP_OPTIONS } from '../../../../config/constants';

import * as query from './query.graphql';

import './style.scss';

const VolunteerWorkSearch = () => {
  const { t } = useTranslation();

  return (
    <div className="VolunteerWorkPage">
      <SearchKit
        uri={APP_OPTIONS?.parameters.apolloSearchUrl}
        query={query}
        pageSize={6}
        defaultSorting="relevance"
        useRouting={false}
      >
        {
          (data) => {
            if (!data) {
              return;
            }

            return (
              <div className="VolunteerWorkSearch">
                <VolunteerWorkSearchBar />
                <VolunteerWorkSearchResults data={data.nLDoetVolunteerWorkSearch} />
                <SearchLoadMore
                  className="VolunteerWorkSearch__showmore"
                  data={data.nLDoetVolunteerWorkSearch}
                  label={t('show_more_organisations')}
                />
              </div>
            );
          }
        }
      </SearchKit>
    </div>
  );
};

export default VolunteerWorkSearch;
